<template>
    <div class="filter-sort">
        <span class="iconfont icon-paixu"></span>
        <a-select :value="sortType" @change="chagneSortType">
            <template #suffixIcon><caret-down-outlined /></template>
            <a-select-option :value="item.value" v-for="item in list" :key="item.value">{{item.title}}</a-select-option>
        </a-select>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { CaretDownOutlined } from '@ant-design/icons-vue';

export default defineComponent({
    props:['sortType','chagneSortType','list'],
    components:{CaretDownOutlined},
})
</script>

<style lang="scss">
.filter-sort {
    position: relative;
    width:auto;
    display: inline-block;
    .iconfont {
        position: absolute;
        left:6px;
        top:5px;
        z-index: 9;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        padding-left: 24px;
    }
    .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        border-color:#aaa;
    }
    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
        box-shadow: none
    }    
}
</style>